import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

export function Wrapper(props: Props) {
  return <div className="mx-auto w-full max-w-screen-2xl p-8" {...props} />;
}
